import React from "react";

export default function Rhombus() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path stroke="#DDE0E4" strokeWidth={5} d="M2.751 3.001h27v27h-27z" />
      <path fill="#000" d="m8 16.34 7.778-7.778 7.779 7.778-7.779 7.778z" />
    </svg>
  );
}
